





















































import { Vue, Component, Emit, PropSync, Prop } from 'vue-property-decorator';

import HelpMessage from "./HelpMessage/HelpMessage.vue";
import Icon from './Icon/Icon.vue';
import { SelectOptionData } from './Pi/types';

@Component({
  components: {
    HelpMessage,
    Icon
  }
})
export default class PiTabs extends Vue {
  @Prop() tabs!: Array<SelectOptionData>

  @PropSync('current') selectedTab!: SelectOptionData['value'] | null

  @Prop({ type: Boolean, default: false }) multiline!: boolean

  @Prop({ type: Boolean, default: false }) canUncheck!: boolean

  @Emit()
  tabClick(tabValue: SelectOptionData['value'] | null) {
    return tabValue
  }

  onTabClick(tab: SelectOptionData) {
    const { value } = tab
    const selectedTab = this.canUncheck && (this.selectedTab === value) ? null : value

    this.selectedTab = selectedTab

    this.tabClick(selectedTab)
  }

  get selectedTabOption() {
    return this.tabs.find(t => t.value === this.selectedTab)
  }
}
